// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StrikePrice[data-v-19ac411a]{text-decoration:line-through;color:#999}", ""]);
// Exports
module.exports = exports;
